<template>
  <div>
    <Breadcrumbs :title="'Home'"></Breadcrumbs>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Home",
  components: {
    Breadcrumbs
},
  data: function () {
    return {
      statistics: [],
      count: 0,
      statsNotFound: require("@/assets/img/stats_empty.png"),
      role: localStorage.getItem('role') || null,
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
    
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },

  watch: {

  },

  methods: {
    stringFormatting(str) {
      return str.replace(/_/g, " ")
    },
    memberCount(value) {
      this.count = value;
    }
  },

};
</script>